import en_app from './en-us/app.json';

// merge english sources
export const en = {
  translation: Object.assign({}, en_app),
};
